<template>
	<div class="form__login">
		<div class="form__login__fields">
			<InputText
				id="txt_login"
				v-model="email"
				class="form__login__fields__item"
				:label="$t('typeEmail')"
				placeholder="E-mail"
			/>
			<a @click="setStep('login')">← {{ $t('backLogin') }}</a>
		</div>
		<Button
			:label="$t('send')"
			semantic-class="mini"
			:loading="isLoading"
			@click="enviaEmailParaRedefinirSenha"
		/>
	</div>
</template>

<script>
import { mapMutations } from 'vuex'

import InputText from '../../../components/InputText/InputText'
import Button from '../../../components/Button/Button'
import { enviarEmailParaRedefinirSenha } from '../../../services/requests/AccountRequests.js'

export default {
	components: { Button, InputText },
	props: {
		setStep: Function,
	},
	data() {
		return {
			email: '',
			isLoading: false,
		}
	},
	methods: {
		...mapMutations('moduleMessages', ['mutationShowMessage']),

		/**
		 * Faz o envio para o e-mail, com o link necessário para resetar a senha do usuário
		 */
		enviaEmailParaRedefinirSenha() {
			this.isLoading = true
			var body = { email: this.email }
			enviarEmailParaRedefinirSenha(body)
				.then((response) => {
					if (response.status === 200) {
						this.setStep('recover-success')
					} else {
						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageText: response.data,
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
						})
					}
					this.isLoading = false
				})
				.catch((err) => {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageText: err.response.data,
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
					this.isLoading = false
				})
		},
	},
}
</script>

<style scoped>
.form__login {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	font-size: 0.75rem;
}

.form__login__fields {
	display: flex;
	flex-direction: column;
	padding-top: 3.21rem;
	padding-bottom: 3.75rem;
	width: 100%;
	justify-content: space-between;
}

.form__login__fields a {
	color: (--color-navy-blue);
	cursor: pointer;
}
</style>
